import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import DropdownSelect, { SelectType } from '../../../components/DropdownSelect';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import ProductController, {
  CategoryType,
  ProductType,
} from '../../../controller/ProductController';
import { useToast } from '../../../controller/ToastController';
import { AuthContext } from '../../../navigation/AuthProvider';
import { CurrentStoreContext } from '../../../controller/StoreController';

const TimeProductIndex = () => {
  const showToast = useToast();
  const navigate = useNavigate();
  const [allCategoryList, setAllCategoryList] = useState<CategoryType[]>([]);
  const [productList, setProductList] = useState<ProductType[]>([]);
  const [searchedList, setSearchedList] = useState<ProductType[]>([]);
  const [isChange, setIsChange] = useState<boolean>(false);

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const [categoryId, setCategoryId] = useState<number>(-1);

  // select item
  const [categoryList, setCategoryList] = useState<SelectType[]>([
    { key: 0, value: -1, name: '전체', label: '전체' },
  ]);

  const [isHide, setIsHide] = useState<boolean>(false);
  const [isSold, setIsSold] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>('');
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const onChangeHide = () => {
    setIsHide(!isHide);
    setIsSold(false);
  };
  const onChangeSold = () => {
    setIsSold(!isSold);
    setIsHide(false);
  };

  const onChange_categoryId = (e: any) => {
    setCategoryId(e.value);
    if (isChange) setVisibleConfirm(true);
    else updateCategoryProduct(e.value);
  };

  const updateCategoryProduct = (category_id: number) => {
    if (category_id === -1) getAllProduct();
    else getCategoryProduct(category_id);
    setVisibleConfirm(false);
    setIsChange(false);
  };

  const onChangeSource = (index: number) => {
    let searchedTemp = searchedList;
    if (isHide) {
      if (searchedTemp[index].is_hide === 1) {
        searchedTemp[index].is_hide = 0;
      } else {
        searchedTemp[index].is_hide = 1;
      }
    } else if (isSold) {
      if (searchedTemp[index].is_soldout === 1) {
        searchedTemp[index].is_soldout = 0;
      } else {
        searchedTemp[index].is_soldout = 1;
      }
    }
    setSearchedList(searchedTemp);
    const mergedArray = productList.map((item) => {
      const matchingObj = searchedTemp.find((searchedItem) => item.prd_id === searchedItem.prd_id);
      return matchingObj ? { ...item, ...matchingObj } : item;
    });
    setProductList(mergedArray);
    setIsChange(true);
  };

  const onChangeAllSource = () => {
    let searchedTemp = searchedList;
    if (isHide) {
      if (searchedList.every((item) => item.is_hide === 1))
        searchedTemp = searchedTemp.map((item: ProductType) => ({ ...item, is_hide: 0 }));
      else {
        searchedTemp = searchedTemp.map((item: ProductType) => ({ ...item, is_hide: 1 }));
      }
    } else if (isSold) {
      if (searchedList.every((item) => item.is_soldout === 1))
        searchedTemp = searchedTemp.map((item: ProductType) => ({ ...item, is_soldout: 0 }));
      else {
        searchedTemp = searchedTemp.map((item: ProductType) => ({ ...item, is_soldout: 1 }));
      }
    }
    setSearchedList(searchedTemp);

    const mergedArray = productList.map((item) => {
      const matchingObj = searchedTemp.find((searchedItem) => item.prd_id === searchedItem.prd_id);
      return matchingObj ? { ...item, ...matchingObj } : item;
    });
    setProductList(mergedArray);
    setIsChange(true);
  };

  // 카테고리 내의 상품 목록
  // const getProductList = (id: number) => {
  //   let productTemp: ProductType[] = [];
  //   if (id === -1) {
  //     allCategoryList.map((item: CategoryType) => {
  //       const filteredList = item.product_list.filter(
  //         (addedItem: ProductType) =>
  //           !productTemp.some(
  //             (item: ProductType) =>
  //               item.prd_id === addedItem.prd_id && item.is_set === addedItem.is_set,
  //           ),
  //       );
  //       productTemp = [...productTemp, ...filteredList];
  //     });
  //   } else {
  //     const categoryItem = allCategoryList.find((item: CategoryType) => item.category_id === id);
  //     if (categoryItem) {
  //       productTemp = categoryItem.product_list;
  //     }
  //   }
  //   // console.log('getProductList', id, productTemp);
  //   setProductList([...productTemp]);
  //   getSearchResult(productTemp);
  // };

  // 검색 결과
  const getSearchResult = (productList: ProductType[]) => {
    setSearchedList(productList.filter((item: ProductType) => item.prd_name.includes(keyword)));
  };

  const navigateProductInfo = async (productInfo?: ProductType) => {
    if (!isHide && !isSold) {
      if (productInfo) {
        navigate(`/product/timeproduct/edit`, { state: { productInfo } });
      } else navigate(`/product/timeproduct/edit`);
    }
  };

  // API 호출
  const getCategoryData = async () => {
    try {
      const oRes = await ProductController.getAllCateProduct(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getCategoryData', oResponse);
        if (oResponse.data) {
          setAllCategoryList([...oResponse.data]);
          let categoryTemp: any = [{ key: 0, value: -1, name: '전체', label: '전체' }];
          oResponse.data.map((item: CategoryType, index: number) => {
            categoryTemp.push({
              key: index + 1,
              value: item.category_id,
              name: item.category_name,
              label: item.category_name,
            });
          });
          setCategoryList([...categoryTemp]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const getAllProduct = async () => {
    try {
      const oRes = await ProductController.getAllProductList(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getAllProductList', oResponse);
        if (oResponse.data) {
          setProductList([...oResponse.data]);
          getSearchResult(oResponse.data);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const getCategoryProduct = async (category_id: number) => {
    try {
      const oRes = await ProductController.getCateProduct(currentStore.value, category_id);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getCategoryProduct', oResponse);
        if (oResponse.data.length > 0 && oResponse.data[0].product_list.length > 0) {
          setProductList(oResponse.data[0].product_list);
          getSearchResult(oResponse.data[0].product_list);
        } else {
          console.log('none data');
          setProductList([]);
          setSearchedList([]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const editProductSold = async (category_id?: number) => {
    try {
      const productTemp: any = [];
      searchedList.map((item: ProductType) => {
        productTemp.push({
          store_id: currentStore.value,
          product_id: item.prd_id,
          is_set: item.is_set,
          is_hide: item.is_hide,
          is_soldout: item.is_soldout,
        });
      });
      //
      const oRes = await ProductController.setSupplyProduct(productTemp);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('setSupplyProduct', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('상품 정보를 수정했어요');
          if (category_id) {
            updateCategoryProduct(category_id);
          }
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getCategoryData();
  }, []);
  useEffect(() => {
    getCategoryData();
  }, [currentStore]);
  useEffect(() => {
    // getProductList(categoryId.value);
    getAllProduct();
  }, [allCategoryList]);

  interface MenuItemProps {
    item: ProductType;
    index: number;
  }

  const RenderMenuItem = ({ item, index }: MenuItemProps) => {
    return (
      <div
        className={`menuItem 
        ${item.is_hide === 1 && 'hide'} 
        ${item.is_soldout === 1 && 'sold'} `}
        key={index}>
        <div className="row">
          {(isHide || isSold) && (
            <input
              type="checkbox"
              value={isHide ? item.is_hide : item.is_soldout}
              autoFocus={false}
              checked={isHide ? item.is_hide === 1 : item.is_soldout === 1}
              onChange={() => onChangeSource(index)}
            />
          )}
          <div className="column">
            <div className="row gap">
              <h4>{item.prd_name}</h4>
              {item.is_set === 1 && <div className="setBadge">SET</div>}
              {item.is_soldout === 1 && <h5>SOLD OUT</h5>}
              {item.is_hide === 1 && (
                <img src={`${process.env.PUBLIC_URL}/svg/ic_blind.svg`} alt="ic" />
              )}
            </div>
            <h5>{item.prd_base_price.toLocaleString()}원</h5>
          </div>
        </div>
        <div className="row">
          <div className="imgWrap">
            {(item.is_hide === 1 || item.is_soldout === 1) && (
              <div className={`blindImg ${item.is_soldout === 1 && 'sold'}`}>
                {item.is_soldout === 1 && 'SOLD OUT'}
              </div>
            )}
            {item.url_path !== '' && item.url_path !== null && <img src={item.url_path} alt="ic" />}
          </div>
          {item.is_set === 0 ? (
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
              alt="ic"
              onClick={() => navigateProductInfo(item)}
            />
          ) : (
            <div className="spaceWrap" />
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Style>
        <div className="contentContainer">
          <button className="addButton" onClick={() => navigateProductInfo()}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
            <h4>상품 만들기</h4>
          </button>

          <div className="row gap">
            <div className="search">
              <input
                type="text"
                value={keyword}
                placeholder="메뉴명을 입력해주세요."
                autoFocus={false}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    getSearchResult(productList);
                  }
                }}
                onBlur={() => getSearchResult(productList)}
              />
              <button className="searchBox" onClick={() => getSearchResult(productList)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_search_grey.svg`} alt="search" />
              </button>
            </div>
            <button className={`optionButton ${isHide && 'active'}`} onClick={onChangeHide}>
              <h5>숨김</h5>
            </button>
            <button className={`optionButton ${isSold && 'active'}`} onClick={onChangeSold}>
              <h5>품절</h5>
            </button>
          </div>
          <DropdownSelect
            options={categoryList}
            defaultValue={categoryList[0]}
            onChangeValue={onChange_categoryId}
          />
          <div className="optionWrap">
            {isHide || isSold ? (
              <label htmlFor="checkAll">
                <input
                  id="checkAll"
                  type="checkbox"
                  autoFocus={false}
                  checked={
                    isHide
                      ? searchedList.every((item) => item.is_hide === 1)
                      : searchedList.every((item) => item.is_soldout === 1)
                  }
                  onChange={onChangeAllSource}
                />
                전체선택
              </label>
            ) : (
              <div />
            )}
          </div>
          {searchedList.length > 0 ? (
            <div className="menuList">
              {searchedList.map((item: ProductType, index: number) => {
                return (
                  (item.prd_type === 3 || item.prd_type === 4) && (
                    <RenderMenuItem key={index} item={item} index={index} />
                  )
                );
              })}
            </div>
          ) : (
            <div className="noneWrap">
              <h3>상품을 등록해주세요</h3>
            </div>
          )}
          <button className={`submitButton`} onClick={() => editProductSold()}>
            저장
          </button>
        </div>
      </Style>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`변경 내역이 저장되지 않았어요\n상품 변경 내역을 저장할까요?`}
        onCancelText="취소"
        onConfirmText="저장"
        onCancel={() => updateCategoryProduct(categoryId)}
        onConfirm={() => editProductSold(categoryId)}
      />
    </>
  );
};

export default TimeProductIndex;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  label {
    display: flex;
    align-items: center;
    gap: 16px;
    color: #555555;
    font-size: 16px;
    line-height: 20px;
  }
  input[type='checkbox'] {
    accent-color: #40977f;
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 20px;

    h4 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .menuList {
    padding: 4px 0 10px 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .menuItem {
      min-height: 86px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2px 20px;
      border: 1px solid #cecece;
      border-radius: 5px;
      cursor: pointer;

      .setBadge {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50px;
        padding: 2px 10px;
        background: #ff7e7e;
        font-size: 12px;
        line-height: 16px;
        color: #ffffff;
        font-weight: 500;
      }

      .column {
        gap: 6px;
        .row {
          gap: 8px;
        }
      }
      h4 {
        color: #555555;
        font-weight: 600;
      }
      h5 {
        color: #555555;
        font-weight: 400;
      }
      .row.gap {
        gap: 8px;

        h5 {
          color: #ff6060;
          font-weight: 600;
        }
      }
      .row {
        gap: 20px;

        .imgWrap {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 75px;
          height: 64px;
          border-radius: 5px;
          background: #ffffff;
          .blindImg {
            position: absolute;
            width: 75px;
            height: 64px;
            border-radius: 5px;
            background: rgba(78, 78, 78, 0.15);
          }
          .blindImg.sold {
            background: rgba(78, 78, 78, 0.35);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 12px;
            line-height: 16px;
            font-weight: 600;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 5px;
          }
        }
      }
    }
    .menuItem.sold {
      background: #c7c7c7 !important;
      border: 1px solid #a7a7a7;
    }
    .menuItem.hide {
      background: #e5e5e5;
    }
  }

  input {
    width: 100%;
    padding: 10px 12px 10px 30px;
    border: 1px solid #cecece;
    border-radius: 5px;
    background: #f7f7f7;
  }
  input::placeholder {
    color: #a7a7a7;
  }

  .row.gap {
    gap: 10px;
  }

  .search {
    width: 75%;
    position: relative;

    .searchBox {
      top: 0;
      padding: 8px 0;
      position: absolute;
      display: flex;
      align-items: center;
      cursor: pointer;
      right: 14px;
    }
  }
  .optionButton {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 9px 28px;
    border-radius: 5px;
    border: 1px solid #cecece;
    background: #f7f7f7;
    h5 {
      color: #555555;
    }
  }
  .optionButton.active {
    border: 1px solid #4dd2ae;
    background: #ecf5f3;
    h5 {
      color: #40977f;
    }
  }

  .optionWrap {
    position: relative;
    display: flex;
    align-items: center;
    padding: 10px 0 6px 0;

    .row {
      gap: 8px;
    }

    .allCheck {
      position: absolute;
      top: 50%;
      left: 0;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  .spaceWrap {
    width: 20px;
    height: 20px;
  }

  .selector {
    margin-top: 16px;
  }

  @media (max-width: 600px) {
    .menuList {
      .menuItem {
        min-height: 70px;
        padding: 2px 14px;
        .setBadge {
          padding: 2px 8px;
          font-size: 12px;
          line-height: 14px;
        }
        .column {
          .row {
            gap: 6px;
          }
        }
        h4 {
          font-size: 14px;
        }
        h5 {
          font-size: 12px;
        }
        .row.gap {
          gap: 6px;
        }
        .row {
          gap: 10px;

          .imgWrap {
            width: 60px;
            height: 60px;
            .blindImg {
              width: 60px;
              height: 60px;
            }
            .blindImg.sold {
              font-size: 10px;
            }
          }
        }
      }
    }
    input {
      padding: 10px 0 10px 10px;
      border: 1px solid #cecece;
      border-radius: 5px;
      background: #f7f7f7;
    }
    .search {
      width: 70%;
      position: relative;

      .searchBox {
        right: 8px;
      }
    }
    .row.gap {
      gap: 6px;
    }
    .optionButton {
      padding: 9px 12px;
      h5 {
        font-size: 12px;
        color: #555555;
      }
    }
  }
`;
